// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__0peLX","lds-dual-ring":"Loading_lds-dual-ring__vhib2"};